import React, { useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useAdminNotification } from './useAdminNotifications';
import { useSignalRListener } from '../../../signalR/useSignalRListener';

export function SystemNotification() {
    const [getLastActiveNotification] = useAdminNotification();

    useSignalRListener('AdminNotification', res => {
        showNotification(res);
    });

    useEffect(() => {
        let isSubscribed = true

        const fetchData = async () => {
            try {
                const notif = await getLastActiveNotification();
                if (notif && isSubscribed) {
                    showNotification(notif.data);
                }
            } catch (error) {
                if (isSubscribed) {
                    console.log(error);
                }
            }
        }

        fetchData();

        return () => isSubscribed = false;
    }, []);

    function showNotification(notification) {
        if (notification)
            toast.info(notification.message, { containerId: "system-notifications" });
    }

    return (
        <div>
            <ToastContainer
                style={{ width: "80%" }}
                containerId="system-notifications"
                position="top-center"
                autoClose={false}
                newestOnTop={false}
                closeOnClick
                pauseOnFocusLoss
                draggable
                theme="light"
                enableMultiContainer={true}
            />
        </div>
    );
}